
import Vue from 'vue'
import store from './../../store'
import sinisterTypesTransformer from './../../transformers/sinister/types'

const save = (sinister, data) => {
  store.dispatch('sinisters/store', data)
}

export default () =>
  Vue.$http.get('/sinisters/roads/types/')
    .then((response) => {
      let data = sinisterTypesTransformer.fetchCollection(response.data)
      return data
    })


// WEBPACK FOOTER //
// ./src/services/sinister/fetchTypes.js